export function normalizeKey(input: string): string {
  return String(input || "")
    .normalize("NFC")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
}

export function stripPunctuation(input: string): string {
  return normalizeKey(input).replace(/[^\p{L}\p{N}\s]/gu, " ").replace(/\s+/g, " ").trim()
}

